/**
 * Display metadata for the consolidated single-funnel pipeline stages.
 *
 * STAGE_ORDER is purely the funnel render order (top → bottom = earliest →
 * latest in the claims lifecycle). It is independent of the SQL precedence
 * rules in universeSql.ts, which control which bucket a claim falls into.
 *
 * Timeline reading: ERR / not adjudicated are the earliest failure points →
 * pended / open-ex are mid-process → payable is adjudicated awaiting payment →
 * denied is a final negative disposition → paid/completed is the end of a
 * successful path → void/refund is a post-payment reversal.
 */
export const STAGE_ORDER = [
  'NOT_ADJUDICATED',
  'ERR',
  'PENDED',
  'OPEN_EX_CODES',
  'PAYABLE',
  'DENIED',
  'COMPLETED',
  'VOID_REFUND',
  'OTHER',
] as const;

export type StageKey = (typeof STAGE_ORDER)[number];

export const STAGE_META: Record<StageKey, {label: string; color: string}> = {
  COMPLETED: {label: 'Paid / completed', color: 'bg-emerald'},
  DENIED: {label: 'Denied', color: 'bg-red-500'},
  VOID_REFUND: {label: 'Void / refund', color: 'bg-slate-500'},
  ERR: {label: 'Validation error (ERR)', color: 'bg-rose-600'},
  OPEN_EX_CODES: {label: 'Open ex codes (in-flight)', color: 'bg-orange-500'},
  PAYABLE: {label: 'Payable (awaiting payment)', color: 'bg-teal-500'},
  PENDED: {label: 'Pended', color: 'bg-amber-500'},
  NOT_ADJUDICATED: {label: 'Not adjudicated', color: 'bg-slate-400'},
  OTHER: {label: 'Other', color: 'bg-slate-300'},
};
